import { createContext, ReactElement, ReactNode, useContext } from 'react'

import { useGetVatRates } from '../hooks/useGetVatRates'
import { VatRate } from '../types/vatRate'

interface ContextState {
  isLoading: boolean
  vatRates: VatRate[]
}

const VatRatesContext = createContext<ContextState | undefined>(undefined)

interface VatRatesContextProviderProps {
  children?: ReactNode
}

export const VatRatesContextProvider = ({ children }: VatRatesContextProviderProps): ReactElement => {
  const { vatRates, isLoading } = useGetVatRates()

  return <VatRatesContext.Provider value={{ isLoading, vatRates }}>{children}</VatRatesContext.Provider>
}

export const useVatRates = () => {
  const context = useContext(VatRatesContext)

  if (!context) {
    throw new Error('VatRatesContext is missing in the module!')
  }

  return context
}
